export const CAMPAIGN_CATEGORIES = [
  {
    id: 'education',
    name: 'Education',
    description: 'Educational institutions, schools, and learning programs',
    icon: '🎓',
    color: '#3B82F6'
  },
  {
    id: 'health',
    name: 'Health & Wellness',
    description: 'Healthcare, mental health, and wellness initiatives',
    icon: '🏥',
    color: '#10B981'
  },
  {
    id: 'environment',
    name: 'Environment',
    description: 'Environmental conservation and sustainability projects',
    icon: '🌱',
    color: '#059669'
  },
  {
    id: 'community',
    name: 'Community',
    description: 'Local community development and social programs',
    icon: '🤝',
    color: '#8B5CF6'
  },
  {
    id: 'arts',
    name: 'Arts & Culture',
    description: 'Arts, culture, museums, and creative projects',
    icon: '🎨',
    color: '#F59E0B'
  },
  {
    id: 'sports',
    name: 'Sports & Recreation',
    description: 'Sports teams, recreation centers, and fitness programs',
    icon: '⚽',
    color: '#EF4444'
  },
  {
    id: 'animals',
    name: 'Animal Welfare',
    description: 'Animal shelters, wildlife conservation, and pet care',
    icon: '🐾',
    color: '#84CC16'
  },
  {
    id: 'disaster',
    name: 'Disaster Relief',
    description: 'Emergency response and disaster recovery efforts',
    icon: '🚨',
    color: '#DC2626'
  },
  {
    id: 'poverty',
    name: 'Poverty & Homelessness',
    description: 'Fighting poverty, homelessness, and food insecurity',
    icon: '🏠',
    color: '#7C3AED'
  },
  {
    id: 'youth',
    name: 'Youth Development',
    description: 'Youth programs, mentorship, and child development',
    icon: '👶',
    color: '#06B6D4'
  },
  {
    id: 'seniors',
    name: 'Senior Care',
    description: 'Elder care, senior services, and aging support',
    icon: '👴',
    color: '#6366F1'
  },
  {
    id: 'technology',
    name: 'Technology',
    description: 'Tech education, digital literacy, and innovation',
    icon: '💻',
    color: '#8B5CF6'
  }
] as const;

export type CategoryId = typeof CAMPAIGN_CATEGORIES[number]['id'];

export interface Category {
  id: CategoryId;
  name: string;
  description: string;
  icon: string;
  color: string;
}

export function getCategoryById(id: CategoryId): Category | undefined {
  return CAMPAIGN_CATEGORIES.find(category => category.id === id);
}

export function getCategoriesByIds(ids: CategoryId[]): Category[] {
  return ids.map(id => getCategoryById(id)).filter(Boolean) as Category[];
}

export function validateCategories(categories: string[]): CategoryId[] {
  const validIds = CAMPAIGN_CATEGORIES.map(c => c.id);
  return categories.filter((cat): cat is CategoryId => validIds.includes(cat as CategoryId));
}
